import type { BrindeResgatado } from "../models/brindesResgatadosFornecedorModel"

export enum BrindesResgatadosFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_FILTRO = "ATUALIZAR_FILTRO",
}

type CarregarAction = {
    type: BrindesResgatadosFornecedorActionsTypes.CARREGAR
    payload: BrindeResgatado[]
}

type AtualizarFiltroAction = {
    type: BrindesResgatadosFornecedorActionsTypes.ATUALIZAR_FILTRO
    payload: { campo: "parteNome" | "email"; valor: string }
}

export type BrindesResgatadosFornecedorActions = CarregarAction | AtualizarFiltroAction
